module.exports = __webpack_public_path__ + "img/icon-ads-account.44cb3fa7.svg";